import React, { useState } from 'react';
import { PAGE_SIZES, DEFAULT_PAGE_SIZE } from '../../constants/admin';

const Pagination = ({ pagination, setPagination, showPageSize = false, onPageSizeChange }) => {
  const [jumpToPage, setJumpToPage] = useState('');

  // Calculate showing X-Y of Z
  const startItem = pagination.total === 0 ? 0 : ((pagination.page - 1) * pagination.limit) + 1;
  const endItem = Math.min(pagination.page * pagination.limit, pagination.total);

  const handleJumpToPage = (e) => {
    if (e.key === 'Enter') {
      const pageNum = parseInt(jumpToPage);
      if (pageNum >= 1 && pageNum <= pagination.pages) {
        setPagination({ ...pagination, page: pageNum });
        setJumpToPage('');
      }
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    if (onPageSizeChange) {
      onPageSizeChange(newSize);
    }
    // Reset to page 1 when changing page size
    setPagination({ ...pagination, page: 1, limit: newSize });
  };

  if (pagination.total === 0) return null;

  return (
    <div className="pagination-wrapper">
      <div className="pagination-info">
        Showing {startItem}-{endItem} of {pagination.total}
      </div>

      <div className="pagination">
        <button
          disabled={pagination.page <= 1}
          onClick={() => setPagination({ ...pagination, page: 1 })}
          title="First page"
        >
          &laquo;
        </button>
        <button
          disabled={pagination.page <= 1}
          onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
          title="Previous page"
        >
          &lsaquo; Prev
        </button>

        <span className="page-indicator">
          Page {pagination.page} of {pagination.pages}
        </span>

        <button
          disabled={pagination.page >= pagination.pages}
          onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
          title="Next page"
        >
          Next &rsaquo;
        </button>
        <button
          disabled={pagination.page >= pagination.pages}
          onClick={() => setPagination({ ...pagination, page: pagination.pages })}
          title="Last page"
        >
          &raquo;
        </button>
      </div>

      <div className="pagination-controls">
        {showPageSize && (
          <div className="page-size-select">
            <label htmlFor="pageSize">Show:</label>
            <select
              id="pageSize"
              value={pagination.limit || DEFAULT_PAGE_SIZE}
              onChange={handlePageSizeChange}
            >
              {PAGE_SIZES.map(size => (
                <option key={size} value={size}>{size}</option>
              ))}
            </select>
          </div>
        )}

        {pagination.pages > 2 && (
          <div className="jump-to-page">
            <label htmlFor="jumpPage">Go to:</label>
            <input
              id="jumpPage"
              type="number"
              min="1"
              max={pagination.pages}
              value={jumpToPage}
              onChange={(e) => setJumpToPage(e.target.value)}
              onKeyDown={handleJumpToPage}
              placeholder="#"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Pagination;
